import { render } from "./footer.vue?vue&type=template&id=36045663&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=36045663&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36045663"]])

export default __exports__